import React from 'react'
import styled from 'styled-components'
import Link from 'components/elements/link'
import { fontWeight } from 'themes/font'
import breakPoints from 'themes/breakPoints'

const ItemStyle = styled(Link)`
  height: 176px;
  padding: 16px;
  border: 1px solid #9b9b9b;
  flex: 1;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 16px 0;
  color: #4a4a4a;
  &:hover {
    border-color: #0984e3;
    h4 {
      color: #0984e3;
    }
  }
  @media (max-width: ${breakPoints.md.max}px) {
    h4 {
      font-size: 1.25rem;
    }
  }
`

const Name = styled.h4`
  font-size: 24px;
  font-weight: ${fontWeight.normal};
`

const Item = ({ name, link }) => {
  return (
    <ItemStyle to={link} target='_blank'>
      <Name>{name}</Name>
    </ItemStyle>
  )
}

export default Item
